import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import BrokenLink from 'icons/svgBrokenLink';
import { Link } from 'react-router-dom';
import VProIcon from '../../icons/VProIcon';


const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.text.primary,
    fontWeight: 600
  }
}));

export default function RequestNewLink() {
  const { textColor } = useStyles();
  return (
    <Box height="100%" width="100%" display="flex" alignItems="center" justifyContent="center">
      <Box maxWidth={350}>
        <Box className="text-center">
          <Typography variant="body2" component="span">
            This link appears to be broken
          </Typography>
          <Box mt={5} mb={5}>
            <BrokenLink />
          </Box>
          <Typography variant="caption" component="p">
            It&apos;s also possible that you have already created your account or it&apos;s been
            more than 24 hours since we sent the link to you. You can request your admin to send you
            a new link.
          </Typography>
        </Box>
        <Box mt={5} textAlign="center">
          <Typography variant="caption" component="p" className={textColor}>
            Already created your account?
            <Link to="/" className="cursor-pointer">
              <Box component="span" color="primary.main" fontWeight={600}>
                {' '}
                Sign In
              </Box>
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
